import { Flex, Text } from '@chakra-ui/react';

export const AppVersion = () => {
    return (
        <Flex className="app-version">
            <Text>APP {process.env.VERSION}</Text>
            <Text>{process.env.COMMIT}</Text>
        </Flex>
    );
};
